import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { FormControl, Validators } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as _ from "lodash";
import { Observable } from "rxjs/Observable";
import swal from "sweetalert2";
import { Combo2Service } from "../../../services/index";
import * as fromRootStore from "../../../reducers";
import * as appConfigActions from "../../../reducers/appconfig.actions";
import {
  ComboService,
  CommonService,
  SampleService,
} from "../../../services/index";

@Component({
  selector: "addedit-invoice-tab",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "./addEditSample.html",
})
export class AddEditSample implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input() active = false;
  @Input() _params: any;
  @Output() tabUpdateEvent = new EventEmitter();

  mode = "Add";
  canSave: boolean = true;
  saveEvent: any;
  ironingList: any;
chk_design: any;
  presentationList: any;
  beltNoList: any;
  designList: any;
  matchColorList: any;
  styleNoList: any;

  @Input() set params(val: any[]) {
    this._params = val;
    this.mode = val["mode"];

    let sampledata = Object.assign({}, val["data"]);
    this.chk_design = sampledata.sample_no;
    this.sampledata = sampledata;

    if (this.mode == "Edit") {
      this.sampledata.sample_color = this.sampledata.sample_color.split(",");
      this.sampledata.mat1_part = this.sampledata.mat1_part.split(",");
      this.sampledata.mat2_part = this.sampledata.mat2_part.split(",");
      this.sampledata.mat3_part = this.sampledata.mat3_part.split(",");
      this.loadeditsamplelist();
      this.onChangeFab(this.sampledata.fab_design_no);
      //    this.onSelectStyle(this.sampledata.style);
    }
  }

  get params(): any[] {
    return this._params;
  }

  page_id: string = Math.random().toString(36).substr(2, 9) + "_";

  isLoading: boolean = false;
  companyList$ = [];
  sampleList: any;
  collarList: any;
  partyList: any = [];
  finyearList = [];
  list: any;
  seasonList = [];
  designnoList = [];
  colorList = [];
  companyList: Observable<any[]>;
  partycodeList = [];
  usagepartslist = [];
  varietyList = [];
  varietyList1 = [];
  shadeList = [];
  itemgroupList = [];
  itemList = [];
  matchingList: any;
  ShirtTypes = ["PLAIN", "PRINT", "PANEL", "CHECKED", "STRIPES"];
  accessoriesList = [
    "BUTTON",
    "THREAD",
    "COLLAR CANVAS",
    "KAJA THREAD",
    "BUTTON THREAD",
    "PLK",
    "CLR-UP",
    "CLR-DN",
    "BND DOWN",
    "BAND UP",
    "CUFF CANVAS",
    "MAIN LABEL",
    "EXTRA LABEL",
    "WASH CARE",
    "BONE",
    "BUT PATTI",
  ];
  sample: any = {};
  // itemList1: Observable<any[]>;

  @ViewChild("partycodeAuto") partycodeAuto;
  @ViewChild("partyAuto") partyAuto;
  @ViewChild("finAuto") gstAuto;

  invnoControl: FormControl = new FormControl();
  ponoControl: FormControl = new FormControl();
  itemCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  finyearCtrl: FormControl = new FormControl();
  partycomboControl: FormControl = new FormControl();
  brandControl: FormControl = new FormControl();

  sampledata: any = {};
  data: any = {};

  groupList: any = [
    {
      main_fab_color: "",
      mat1_des_no: "",
      mat1_color: "",
      mat2_des_no: "",
      mat2_color: "",
      mat3_des_no: "",
      mat3_color: "",
      piping_des_no: "",
      piping_color: "",
      tape_no: "",
      kaja_thread: "",
      button_no: "",
      button_thread: "",
    },
  ];

  constructor(
    public store: Store<fromRootStore.State>,
    public toasterService: ToasterService,
    private commonService: CommonService,
    private combo: Combo2Service,
    private sampService: SampleService,
    public datePipe: DatePipe,
    private comboservice: ComboService
  ) {
    function hasValidItem(input: FormControl) {
      let id = input.value,
        retVal = null;
      if (id == "") {
        retVal = { inValid: true };
      }
      if (id && typeof id === "string") {
        retVal = { inValid: true };
      }
      return retVal;
    }

    this.partyCtrl = new FormControl("", [
      Validators.required,
      hasValidItem.bind(this),
    ]);
    this.data = this.commonService.itemMaster();
    console.log(this.data);
  }
  hotkeys(event) {
    if (this.active) {
    }
  }

  trackByIndex(index: number, value: any) {
    return index;
  }

  ngOnInit(): void {
    if (this.mode == "Add") {
      this.sampledata.date = this.datePipe.transform(new Date(), "yyyy-MM-dd");
      this.getAuto();
      this.getVarietyList();
    }
    this.getSeasonList();
    this.getMatchinglist();
    this.getDesignList();
    this.getStyleNoList();
    this.getmaxSeason();
  }

  /*  tableScroll(){
       
        $('.samplemain').width(window.innerWidth -525);
        $('.samplebody').width(window.innerWidth -485);
        if(window.innerWidth>1500){
            $('.techstyleinput').width(window.innerWidth-1045);
        }else{
            $('.techstyleinput').width(window.innerWidth-865);
        }

    } */

  onSelectStyle(style) {
    this.sampledata.thread_cons = this.data.thread_cons[style][0];
    this.sampledata.thread_type = this.data.thread_type[style][0];
    this.sampledata.bobbin_type = this.data.bobbin_type[style][0];
    this.sampledata.tape_cons = this.data.tape_cons;
    this.sampledata.kthread_cons = this.data.kthread_cons;
    this.sampledata.bthread_cons = this.data.bthread_cons;

    this.collarList = this.data.collar_no[style];
    this.sampledata.bobbin_cons = this.data.bobbin_cons["CASUAL"][0];
    let params = {
      style: style,
    };
    this.sampService.getTrimsList(params).then((res: any) => {
      this.ironingList = res.data;
      this.presentationList = res.presentData;
      if (style == "FORMAL" || style == "CASUAL" || style == "STYLISH FORMAL" || style == "RR CASUAL" || style == "RR FORMAL" || style == "CLUB") {
        this.beltNoList = this.presentationList.slice(0, 1);
        this.sampledata.belt_cons = this.beltNoList[0]["fs_cons"];
      } else {
        this.beltNoList = this.presentationList.slice(0, 2);
        this.sampledata.belt_cons = this.beltNoList[0]["fs_cons"];
      }
    });

    if (style == "FORMAL" || style == "RR FORMAL" || style == "CLUB") {
      this.sampledata.fit = this.data.fit[0];
    } else if (style == "STYLISH FORMAL") {
      this.sampledata.fit = this.data.fit[0];
    } else if (style == "CASUAL" || style == "RR CASUAL") {
      this.sampledata.fit = this.data.fit[1];
    } else if (style == "CLUBWEAR") {
      this.sampledata.fit = this.data.fit[2];
    }
  }

  // onSelectShirtType(shirt_des_type) {
    
  //   if (this.sampledata.fab_design_no) {
  //     if (this.sampledata.shirt_type == "NEW") {
  //       if (this.sampledata.brand == "GREEN OLIVE") {
  //         if (shirt_des_type == "PLAIN") {
  //           this.sampledata.shirt_design_no = "";
  //         } else {
  //           this.generateDNo(this.sampledata.brand);
  //         }
  //       } else {
  //         if (shirt_des_type == "PLAIN") {
  //           this.sampledata.shirt_design_no = "";
  //         } else {
  //           this.generateDNo(this.sampledata.style);
  //         }
  //       }
  //     } else if (
  //       this.sampledata.shirt_type == "CORE" ||
  //       this.sampledata.shirt_type == "GANG"
  //     ) {
  //       this.sampledata.shirt_design_no = this.sampledata.fab_design_no;
  //     }
  //   }
  //   if(shirt_des_type != 'PLAIN'){
  //     this.canSave = false;

  //   }
  // }
  getmaxSeason() {
    this.sampService.getmaxSeason({}).then((res: any) => {
      this.sampledata.season_name = res.data[0].season_name;
    });
  }

  getStyleNoList() {
    this.sampService.getStyleNoList({}).then((res: any) => {
      this.styleNoList = res.data;
    });
  }
  getVarietyList() {
    this.combo.varietyStyleCombo().then((res: any) => {

    let list = [...res.data];
      this.varietyList = list.reduce((unique, o) => {
            if(!unique.some(obj => obj.variety === o.variety)) {
              unique.push(o);
            }
            return unique;
        },[]);
    
      this.varietyList1 =  this.varietyList;
   
    });
    
  }
  // generateDNo(style) {
  //   let params = {
  //     style: style,
  //   };
  //   this.sampService.getDesignNo(params).then((res: any) => {
  //     this.sampledata.shirt_design_no = res.data[0].shirtdno;
  //   });
  // }
  getSeasonList() {
    let params = {
      date: new Date().getFullYear(),
      page: 1,
      start: 0,
      limit: 100,
    };
    this.comboservice.getSeason(params).then((res: any) => {
      this.seasonList = res;
    });
  }

  getMatchinglist() {
    this.sampService.getMatchingList({}).then((res: any) => {
      this.matchingList = res.data;
    });
  }
  getDesignList() {
    this.sampService.getDesignList({}).then((res: any) => {
      this.designList = res.data;
    });
  }

  onSelectDesign(match_design, sampdata) {
    let params = {
      design_no: match_design,
    };
    this.sampService.getMatchColor(params).then((res: any) => {
      this.matchColorList = res.data;
    });

    /*   sampdata.kaja_thread = this.sampledata.kthread_cons;
        sampdata.button_thread = this.sampledata.bthread_cons; */
  }

  ngAfterViewInit() {
    setTimeout(() => {
      $("#" + "date").focus();
    }, 100);
  }

  getAuto() {
    this.sampService.getRefAuto({}).then((res: any) => {
      if (this.mode == "Add") {
        this.sampledata.ref_no = res;
      }
    });
  }

  onChangeFab(fab_design) {
    let params = {
      design_no: fab_design,
    };
    this.sampService.onChangeFab(params).then((res: any) => {
      this.colorList = res.data;
      this.sampledata.fab_style = res.data[0].style;
      this.sampledata.width = res.data[0].recvd_width;
      this.sampledata.shirt_type = res.data[0].design_type;
    });
  }

  onEnterKeyPressed($event, nextEl: string) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");

      $("#" + nextEl).focus();
    }
  }

  onGoToNextFld($event, fld, ind) {
    let nxtInd = ind,
      fab_color = this.groupList[ind]["main_fab_color"];

    let nxtRow = $("#row-" + ind).next("tr");

    if (fab_color != "") {
      if (fld == "fab_color" && nxtRow.length == 0) {
        for (let i = 0; i < this.groupList.length; i++) {
          if (ind + 1 == this.groupList.length) {
            this.groupList.push({
              main_fab_color: "",
              mat1_des_no: "",
              mat1_color: "",
              mat2_des_no: "",
              mat2_color: "",
              mat3_des_no: "",
              mat3_color: "",
              piping_des_no: "",
              piping_color: "",
              tape_no: "",
              kaja_thread: "",
              button_no: "",
              button_thread: "",
            });

            nxtInd = this.groupList.length - 1;
          }
        }
      }
    }
    setTimeout(() => {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + fld + "-" + nxtInd).focus();
    }, 100);
  }

  onGoToUpAndDown($event, fld, arrow, ind) {
    //
    $event.preventDefault();
    if ($("typeahead-container").length > 0) {
      return false;
    }
    if (arrow == "up") ind--;
    else ind++;

    if ($("#" + this.page_id + fld + "-" + ind).length > 0) {
      $("#" + this.page_id + fld + "-" + ind).focus();
    }
  }

  onkeyrightleft($event, arrow, fld) {
    $event.preventDefault();
    if ($("typeahead-container").length > 0) {
      return false;
    }

    if ($("#" + this.page_id + fld).length > 0) {
      $("#" + this.page_id + fld).focus();
    }
  }

  loadeditsamplelist() {
    let params = {
      samp_id: this.sampledata.samp_id,
    };
    this.sampService.getEditSampleList(params).then((res: any) => {
      this.groupList = res.data;
      if (res.data.length == 0) {
        this.groupList.push({
          main_fab_color: "",
          mat1_des_no: "",
          mat1_color: "",
          mat2_des_no: "",
          mat2_color: "",
          mat3_des_no: "",
          mat3_color: "",
          piping_des_no: "",
          piping_color: "",
          tape_no: "",
          kaja_thread: "",
          button_no: "",
          button_thread: "",
        });
      }
    });
  }

  onDeleteRow($event, fld, ind) {
    $event.preventDefault();
    let that = this;
    swal({
      title: "Are you sure to delete this row?",
      type: "warning",
      focusCancel: true,
      showCancelButton: true,
      confirmButtonText: "Yes, Delete it!",
      cancelButtonText: "No, want to change",
    }).then(
      function () {
        if (that.groupList.length > 1) {
          that.groupList.splice(ind, 1);

          if ($("#" + this.page_id + fld + "-" + (ind - 1)).length > 0) {
            $("#" + this.page_id + fld + "-" + (ind - 1)).focus();
          } else if ($("#" + this.page_id + fld + "-" + (ind + 1)).length > 0) {
            $("#" + this.page_id + fld + "-" + (ind + 1)).focus();
          }
        }
      },
      function (dismiss) {}
    );
  }

  filterItems(name: string, comboType: string) {
    let list: any[];
    if (comboType == "Company") {
      list = this.companyList$;
    } else if (comboType == "Party") {
    }
    name = _.escapeRegExp(name);
    return list.filter((item) => new RegExp(name, "gi").test(item.name));
  }

  onSelectItem($event, m1, m2, id) {
    this.sampledata[m1] = $event.item.mtr / $event.item.qty;
    this.sampledata[m2] = $event.item.mtr / $event.item.qty;
    this.onEnterKeyPressed("", id);
  }

  onEnterdesignno(list, ind) {
    let params = {
      design_no: list.design_no,
    };

    this.sampService.designlist(params).then((res: any) => {
      this.shadeList = res;

      // this.calcConsumption('$event',ind);
    });
  }

  oncheckemptyrow() {
    let list = this.groupList;
    let sampleList = [];
    for (let i = 0; i < list.length; i++) {
      if (list[i].main_fab_color != "") {
        sampleList.push(list[i]);
      }
    }
    this.groupList = sampleList;

    let errors: string[] = [];
    if (!this.sampledata.sample_no) {
      errors.push("Sample No is required");
    }
    if (!this.sampledata.fab_design_no) {
      errors.push("Fabric Design No is required");
    }
    if (!this.sampledata.shirt_design_no) {
      errors.push("Shirt Design No is required");
    }
    if (errors.length > 0) {
      swal("VALIDATION ERROR", errors.join("\n"), "warning");
      return;
    }

    this.onSaveSample();
  }

  calcCons(parts, full, half) {
    if (parts.length <= 0) {
      this.sampledata[full] = 0;
      this.sampledata[half] = 0;
    } else {
      let totcons = 0;
      for (let i = 0; i < parts.length; i++) {
        for (let j = 0; j < this.matchingList.length; j++) {
          if (parts[i] == this.matchingList[j].parts) {
            totcons +=
              this.matchingList[j]["mtr"] / this.matchingList[j]["qty"];
          }
        }
        this.sampledata[full] = totcons.toFixed(2);
        this.sampledata[half] = totcons.toFixed(2);
      }
    }
  }
  samplenoExist(sample_no) {
    
    if(this.mode == "Edit"){

      if(this.chk_design != sample_no){

        swal("PLEASE ENTER SAME SAMPLE NO FOR EDIT MODE");
        return
      }

    }
    let params = {
      sample_no: sample_no,
    };
    this.sampService.samplenoExist(params).then((res: any) => {
      if (!res.success) {
        let message = res.message;
        swal(message);
        this.sampledata.sample_no = "";
      } else {
        this.sampledata.brand = res.data.brand;
        this.sampledata.style = res.data.style;
        this.sampledata.season_name = res.data.season;
        this.sampledata.fab_design_no = res.data.fab_design_no;
        this.sampledata.shirt_design_no = res.data.shirt_no;
        this.sampledata.sample_no = res.data.sample_no;
        this.sampledata.shirt_des_type = res.data.variety_type;
        this.onChangeFab(this.sampledata.fab_design_no);
        this.onSelectStyle(this.sampledata.style);
      }
    });
  }
  onEnterShirtDesignno(shirt_design_no) {
    let params = {
      shirt_design: shirt_design_no,
     style: this.sampledata.style
    };
    let that = this;

    that.sampService
      .onEnterShirtDesignno(params)
      .then(function (res: any) {
        if (res) {
          that.canSave = true;
          swal(
            "SHIRT DESIGN NO ALREADY EXISTS...PLEASE ENTER ALTERNATE SHIRT DESIGN NO..."
          );
        } else {
          that.canSave = false;
        }
      })
      .catch(function (error: any) {
        let res = JSON.parse(error._body);
        swal("ERROR", res.description || res.message, "error");
      });
  }
  canEnableSave(shirt_design_no){
    if(shirt_design_no){
      this.canSave = false;
    }
  }
  onSaveSample(): void {
    let params: any = Object.assign({}, this.sampledata);
    params["tabevent"] = undefined;
    if (this.sampledata.sample_color) {
      params["color"] = this.sampledata.sample_color.toString();
    } else {
      params["color"] = this.sampledata.sample_color;
    }
    params["mat1_part"] = this.sampledata.mat1_part
      ? this.sampledata.mat1_part.toString()
      : "";
    params["mat2_part"] = this.sampledata.mat2_part
      ? this.sampledata.mat2_part.toString()
      : "";
    params["mat3_part"] = this.sampledata.mat3_part
      ? this.sampledata.mat3_part.toString()
      : "";
    params["extra_label"] = this.sampledata.extra_label || "";
    params["but_placket"] = this.sampledata.but_placket || "";
    params["wash_shrink"] = this.sampledata.wash_shrink || "";
    params["mat1_full_cons"] = this.sampledata.mat1_full_cons || "";
    params["mat2_full_cons"] = this.sampledata.mat2_full_cons || "";
    params["mat3_full_cons"] = this.sampledata.mat3_full_cons || "";
    params["mat1_half_cons"] = this.sampledata.mat1_half_cons || "";
    params["mat2_half_cons"] = this.sampledata.mat2_half_cons || "";
    params["mat3_half_cons"] = this.sampledata.mat3_half_cons || "";
    params["mode"] = this.mode;
    params["groupList"] = JSON.stringify(this.groupList);
    let that = this;
    swal({
      title: "Are you sure to save this Sample?",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, save it!",
      cancelButtonText: "No, want to change",
    }).then(
      function () {
        that.isLoading = true;
        that.sampService
          .addUpdateSample(params)
          .then(function (res: any) {
            that.isLoading = false;
            if (that.saveEvent) {
              that.saveEvent.emit();
            }

            if (res.success) {
              that.toasterService.pop({
                bodyOutputType: 1,
                type: "success",
                title: "SUCCESS",
                body: res.message,
              });
              that.store.dispatch(new appConfigActions.SetLoadInvoice(true));
              if (that.mode == "Add") {
                that.getAuto();
                let tabObj = {
                  action: "CloseTab",
                  params: {},
                };
                that.tabUpdateEvent.emit(tabObj);
                //    that.loadInvNoItemList();
              } else {
                let tabObj = {
                  action: "CloseTab",
                  params: {},
                };
                that.tabUpdateEvent.emit(tabObj);
              }
            } else {
              swal("ERROR", res.message, "error");
            }
          })
          .catch(function (error: any) {
            that.isLoading = false;
            let res = JSON.parse(error._body);
            swal("ERROR", res.description || res.message, "error");
          });
      },
      function (dismiss) {}
    );
  }

  ngOnDestroy() {}
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/sample/addEditSample.ts